// import { SessionData } from "@/app/types/types";

import { SessionData } from "../ModalClass/types";

export class SessionService {
    private authApiUrl: string | undefined;
    private addressApiUrl: string | undefined;
    private sessionApiUrl: string | undefined;
    private dupAddressApiUrl: string | undefined;
  
    constructor() {
      this.authApiUrl = process.env.REACT_APP_UQUAL_AUTHAPI;
      this.addressApiUrl = process.env.REACT_APP__ADDRESSAPI;
      this.sessionApiUrl = process.env.REACT_APP_SESSIONAPI;
      this.dupAddressApiUrl = process.env.REACT_APP__UQUAL_DUPADDRESSAPI;
    }
  
    getSession = async (): Promise<SessionData | null> => {
      let apiUrl = process.env.REACT_APP_API_URL;
      console.log(apiUrl)
      const requestOptions = {
        method: 'POST',
        headers: {
          accept: 'application/json',
          Authorization: 'Basic a2luZXRpYzpTZWN1UmUhS2lOZXRpYzE=',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
      };
  
      if (this.sessionApiUrl) {
        try {
          const response = await fetch(this.sessionApiUrl, requestOptions);
          if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
          }
          const data = await response.json();
          const token = data.token;
          const success = data.success;
          const ip = data.ip;
  
          return { token, success, ip };
        } catch (error) {
          console.error('Failed to fetch session token:', error);
          return null;
        }
      } else {
        console.error('Session API URL is not defined.');
        return null;
      }
    };
  }
  